import { createFilterSlice } from './filterSlice';

const STORAGE_KEY = 'adminTablePrefs';

/**
 * Saved list prefs for one admin table. The search (kept in the URL) and the current page
 * aren't saved.
 */
const defaultTablePrefs = {
	pageSize: 50,
	sort: [],
	filters: {},
};

/**
 * List prefs for the admin tables (searched in the browser), one entry per table, saved in
 * localStorage like the CRM table prefs. Kept apart from instantSearch, which holds the
 * CRM's Typesense filters. Add a table by adding its key here; its action is
 * set<Table>(prefs) with the whole prefs object.
 */
const defaultFilters = {
	featureFlags: defaultTablePrefs,
	brokerGroups: defaultTablePrefs,
	users: defaultTablePrefs,
	imports: defaultTablePrefs,
	formFieldConfigs: { ...defaultTablePrefs, sort: [{ field: 'label', sort: 'asc' }] },
};

export const adminTablePrefsSlice = createFilterSlice({
	sliceName: 'adminTablePrefs',
	storageKey: STORAGE_KEY,
	defaultFilters,
});

export const DEFAULT_ADMIN_TABLE_PREFS = defaultTablePrefs;

/** The set<Table> action for an admin table key, e.g. 'featureFlags' → setFeatureFlags. */
export const setAdminTablePrefs = (table, prefs) =>
	adminTablePrefsSlice.actions[`set${table[0].toUpperCase()}${table.slice(1)}`](prefs);

export default adminTablePrefsSlice.reducer;
